import { Injectable, Inject } from '@angular/core';
import { NavMenuItem } from '../viewmodels/NavMenuItem';

@Injectable()
export class NavMenuService {
  
  visible: boolean;
  toggleMenu: boolean;
  navItems: NavMenuItem[] = [
    //{
    //  displayName: 'Property Search',
    //  name: 'propertySearch',
    //  links: null,
    //  path: '/rodcore',
    //  isActive:true
    //},
    {
      displayName: 'Land Records 1962-Now',
      name: 'RecordedLand',
      links: [
        {
          displayName: 'Name',
          path: 'rec-name-search'
        },
        //{
        //  displayName: 'Address',
        //  path: 'rec-address-search'
        //},
        //{
        //  displayName: 'Date',
        //  path: 'rec-date-search'
        //},
        //{
        //  displayName: 'Value',
        //  path: 'rec-value-search'
        //},
        {
          displayName: 'Book & Page',
          path: '/rec-bp-search'
        }
        //},
        //{
        //  displayName: 'Document No.',
        //  path: '/rec-doc-search'
        //}
      ],
      path: null,
      isActive: false
    },
    //{
    //  displayName: 'Registered Land',
    //  name: 'registeredLand',
    //  links: [
    //    {
    //      displayName: 'Name',
    //      path: 'reg-name-search'
    //    },
    //    {
    //      displayName: 'Address',
    //      path: 'reg-address-search'
    //    },
    //    {
    //      displayName: 'Date',
    //      path: 'reg-date-search'
    //    },
    //    {
    //      displayName: 'Certificate',
    //      path: 'reg-certificate-search'
    //    },
    //    {
    //      displayName: 'Value',
    //      path: 'reg-value-search'
    //    },
    //    {
    //      displayName: 'Document No.',
    //      path: 'reg-document-no-search'
    //    },
    //    {
    //      displayName: 'Owner',
    //      path: 'reg-owner-search'
    //    }
    //  ],
    //  path: null,
    //  isActive: false
    //}
  ];

  constructor() {
    this.visible = true;

   
  }

  hide() { this.visible = false; }

  show() { this.visible = true; }

  getMenu() {
    return this.navItems;
  }

  pushNavMenuItem(newItem: NavMenuItem) {
    this.navItems.push(newItem);
  }
  
}
